// todo: this shouldn't be used anywhere since this is in the database
const isMultifamilyOrEquivalent = (sectorType) => {
  return ['student_housing', 'multifamily', 'senior_housing'].includes(sectorType);
};

export { isMultifamilyOrEquivalent };
